import { getDateFromUnixSeconds } from 'modules/common/utils/getDateFromUnixSeconds';
import {
  IChargingModelData,
  IDealChargingModelData,
  IPAYGChargingModelData,
  IPackageChargingModelData,
} from 'modules/payments/types';

export interface ISortChargingModelsParams {
  dealChargingModelsData: IDealChargingModelData[];
  packageChargingModelsData: IPackageChargingModelData[];
  paygChargingModelData: IPAYGChargingModelData;
}

type BundleModel = IDealChargingModelData | IPackageChargingModelData;
type SplittedBundleModels = {
  active: BundleModel[];
  inactive: BundleModel[];
};

const splitModels = (models: BundleModel[]) => {
  const now = new Date();

  return models.reduce<SplittedBundleModels>(
    (result, model) => {
      const isExpired = now > getDateFromUnixSeconds(model.expires);
      const isUsed = model.progressValue >= 100;

      if (isExpired || isUsed) {
        result.inactive.push(model);
      } else {
        result.active.push(model);
      }

      return result;
    },
    {
      active: [],
      inactive: [],
    },
  );
};

const compareModelExpiration = (modelA: BundleModel, modelB: BundleModel) =>
  modelA.expires - modelB.expires;

export const sortChargingModels = ({
  dealChargingModelsData,
  packageChargingModelsData,
  paygChargingModelData,
}: ISortChargingModelsParams): IChargingModelData[] => {
  const { active: activePackageModels, inactive: inactivePackageModels } =
    splitModels(packageChargingModelsData);

  const { active: activeDealModels, inactive: inactiveDealModels } =
    splitModels(dealChargingModelsData);

  const activeBundleModels = [
    ...activePackageModels.sort(compareModelExpiration),
    ...activeDealModels.sort(compareModelExpiration),
  ];

  const inactiveBundleModels = [
    ...inactivePackageModels.sort(compareModelExpiration),
    ...inactiveDealModels.sort(compareModelExpiration),
  ];

  return [
    ...activeBundleModels,
    paygChargingModelData,
    ...inactiveBundleModels,
  ];
};
